import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CustomDataGrid from "src/@core/components/data-grid";
// import Action from "../";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
// import DialogEditUserDetails from "../dialog/DialogEditUserDetails";
// import DialogViewUserDetails from "../dialog/DialogViewUserDetails";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import moment from "moment";

function RoleListTable({
  rows,
  totalCount,
  setCurrentPage,
  currentPage,
  setPageSize,
  pageSize,
  toggleDelete,
  permissionList,
  onSuccess,
  onEdit,
}) {
  const [editOpen, setEditOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [viewOpen, setViewOpen] = useState(false);

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case "active":
        return "#6DA544";
      case "inactive":
        return "#E56060";
      case "pending":
        return "#9160E5";
      default:
        return "#667085";
    }
  };

  const navigate = useNavigate();

  const handleEditOpen = (user) => {
    if (onEdit) {
      onEdit(user);
    }
  };

  const handleViewOpen = (user) => {
    setSelectedUser(user);
    setViewOpen(true);
  };

  const handleEditClose = () => {
    setEditOpen(false);
    setSelectedUser(null);
  };

  const handleViewClose = () => {
    setViewOpen(false);
    setSelectedUser(null);
  };

  return (
    <>
      <CustomDataGrid
        rows={rows}
        rowCount={totalCount}
        getRowClassName={(params) => {
          // Add special styling for agent row
          return params.row.userType === "agent" ? "agent-row" : "";
        }}
        sx={{
          "& .agent-row": {
            backgroundColor: "#F8F9FA",
            fontWeight: "bold",
            "& .MuiDataGrid-cell": {
              borderBottom: "2px solid #E0E0E0",
            },
          },
        }}
        columns={[
          {
            field: "role",
            headerName: "User Role",
            flex: 1.5,
            minWidth: 200,
            sortable: false,
            renderCell: ({ row }) => (
              <Typography
                variant="fm-p3"
                color="#101828"
                fontWeight="500"
                noWrap
              >
                {row?.name || "-"}
              </Typography>
            ),
          },
          {
            field:"created_at",
            headerName:"Created At",
            minWidth:200,
            sortable:false,
            renderCell:({row})=>{
              return (
              <Typography variant="fm-p3" color="#101828" fontWeight="500" noWrap>
                {row?.created_at ? moment(row.created_at).format("MMM DD, YYYY hh:mm A") : "-"}
              </Typography>
            )
          }},
          {
            field:"updated_at",
            headerName:"Updated At",
            minWidth:200,
            sortable:false,
            renderCell:({row})=>{
              return (
              <Typography variant="fm-p3" color="#101828" fontWeight="500" noWrap>
                {row?.updated_at ? moment(row.updated_at).format("MMM DD, YYYY hh:mm A") : "-"}
              </Typography>
            )
          }},
          {
            field: "actions",
            headerName: "Action",
            minWidth: 200,
            sortable: false,
            renderCell: ({ row }) => (
              <Box display="flex" gap="10px">
                {/* View button - always visible */}
                {/* <IconButton
                  onClick={() => handleViewOpen(row)}
                  sx={{ bgcolor: "#EDF7FD", borderRadius: "8px", p: 2 }}
                  size="small"
                >
                  <img src={Action} alt="View" />
                </IconButton> */}
                <>

                  <IconButton
                    onClick={() =>
                      navigate(`/roles/edit/${row.id}`, {
                        state: { dataToEdit: row, permissions: permissionList },
                      })
                    }
                    sx={{ bgcolor: "#F9FCE1", borderRadius: "8px", p: 2 }}
                    size="small"
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    sx={{ bgcolor: "#FCE8E1", borderRadius: "8px", p: 2.5 }}
                    size="small"
                    color="secondary"
                    onClick={(e) => toggleDelete(e, row, "user")}
                  >
                    <DeleteIcon />
                  </IconButton>
                </>
              </Box>
            ),
          },
        ]}
        currentPage={currentPage}
        pageSize={pageSize}
        setCurrentPage={setCurrentPage}
        setPageSize={setPageSize}
      />
      {/* <DialogEditUserDetails
        open={editOpen}
        onClose={handleEditClose}
        user={selectedUser}
        onSuccess={onSuccess}
      />
      <DialogViewUserDetails
        open={viewOpen}
        onClose={handleViewClose}
        user={selectedUser}
      /> */}
    </>
  );
}

export default RoleListTable;
